import { API_ENDPOINTS, BASE_URL } from '../../constants/apiEndpoints';
import fetcher from '../../helpers/fetcher';
import { indexedDBManager } from '../../utils/indexedDB';
import { unwrapDataResponse } from '../../utils/unwrapDataResponse';
import type { CreateTaskDto, TaskQueryParams, UpdateTaskDto } from '../../types/task';

export const getTasks = async (params: TaskQueryParams): Promise<any> => {
  const response = await fetcher.get(
    API_ENDPOINTS.TASK.GET_TASK_LIST,
    params,
    {},
    BASE_URL.CONSUMER_PRICE_BASE
  );

  return {
    ...response,
    data: unwrapDataResponse<any>(response.data),
  };
};

export const getRecurrentTasks = (params: TaskQueryParams): Promise<any> => {
  return fetcher.post(
    API_ENDPOINTS.TASK.GET_RECURRENT_TASKS,
    params,
    {},
    BASE_URL.ANALYSIS_SERVICE_BASE
  );
};

export const deleteRecurrentTasks = (id: number): Promise<any> => {
  return fetcher.del(
    `${API_ENDPOINTS.TASK.DELETE_RECURRENT_TASKS}/${id}`,
    {},
    {},
    BASE_URL.CONSUMER_PRICE_BASE
  );
};

export const createTask = (taskData: CreateTaskDto): Promise<any> => {
  return fetcher.post(API_ENDPOINTS.TASK.CREATE_TASK, taskData, {}, BASE_URL.CONSUMER_PRICE_BASE);
};

export const duplicateTask = (id: number): Promise<any> => {
  return fetcher.get(
    `${API_ENDPOINTS.TASK.DUPLICATE_TASK}/${id}/duplicate`,
    {},
    {},
    BASE_URL.CONSUMER_PRICE_BASE
  );
};

export const updateTask = (id: string, taskData: UpdateTaskDto): Promise<any> => {
  return fetcher.patch(
    `${API_ENDPOINTS.TASK.UPDATE_TASK}/${id}`,
    taskData,
    {},
    BASE_URL.CONSUMER_PRICE_BASE
  );
};

export const updateTaskWithSync = async (refId: string, taskData: UpdateTaskDto): Promise<any> => {
  try {
    await indexedDBManager.addToSyncQueue({
      entity: 'task',
      action: 'update',
      data: {
        refId,
        ...taskData,
        updateTime: Date.now(),
      },
      timestamp: Date.now(),
      retryCount: 0,
      synced: 0,
    });

    return {
      success: true,
      message: 'Task update queued for synchronization',
      refId,
    };
  } catch (error) {
    console.error('Failed to queue task update:', error);
    throw error;
  }
};

export const deleteTask = (id: string): Promise<any> => {
  return fetcher.del(
    `${API_ENDPOINTS.TASK.DELETE_TASK}/${id}`,
    {},
    {},
    BASE_URL.CONSUMER_PRICE_BASE
  );
};

export const upsertTask = (taskData: CreateTaskDto): Promise<any> => {
  return fetcher.put(API_ENDPOINTS.TASK.UPSERT_TASK, taskData, {}, BASE_URL.CONSUMER_PRICE_BASE);
};
